import { useEffect } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';

import AnalyticsHelper from '../../helpers/analytics';

/**
 * GA4 only auto-tracks the initial document load, so the SPA reports its own
 * page_view for the first render and for every subsequent route change.
 */
function AnalyticsTracker() {
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		AnalyticsHelper.pageView(location.pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const unlisten = history.listen((nextLocation) => {
			AnalyticsHelper.pageView(nextLocation.pathname);
		});
		return () => {
			unlisten();
		};
	}, [history]);

	return null;
}

export default withRouter(AnalyticsTracker);
